import {
  SET_SEARCH_QUERY,
  SET_SELECTED_RESULT,
  SET_SELECTED_INPUT,
  SET_AUTOCOMPLETE_RESULTS,
} from '../constants/types';

import { setUrl } from '../actions/app';
import { updateUrlSearch } from '../lib/UrlUtils';

const setSearchQuery = userInput => {
  return {
    type: SET_SEARCH_QUERY,
    userInput,
  };
};

export const updateSearchQuery = userInput => (dispatch, getState) => {
  dispatch(setUrl(updateUrlSearch(userInput, getState().app.url)));
  dispatch(setSearchQuery(userInput));
};

export const setAutocompleteResults = searchResults => {
  return {
    type: SET_AUTOCOMPLETE_RESULTS,
    searchResults,
  };
};

export const setSelectedResult = selectedSearchResult => {
  return {
    type: SET_SELECTED_RESULT,
    selectedSearchResult,
  };
};

export const setSelectedInput = selectedInput => {
  return {
    type: SET_SELECTED_INPUT,
    selectedInput,
  };
};
